module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__tourspot-620379a7ba060370737fa15a7c6285b8.svg";